import { ConnectionService } from './connection.service';

class LicenseService {
  constructor() {
    this.licenseConnection = ConnectionService.getAutoReconnectConnection('/license');
    this.connector = this.licenseConnection.start();
  }

  async getEntitlement() {
    await this.connector;
    return await this.licenseConnection.invoke('GetEntitlement');
  }

  async startSession(path) {
    await this.connector;
    return await this.licenseConnection.invoke('StartSession', path, -1);
  }

  async removeSession(user, ip, path, isVideoScopeUsed) {
    await this.connector;
    return await this.licenseConnection.invoke('RemoveSession', user, ip, path, isVideoScopeUsed);
  }

  async ignoreReminders(ignoreReminders) {
    await this.connector;
    return await this.licenseConnection.invoke('IgnoreReminders', ignoreReminders);
  }

  async closeSession(path, videoScope) {
    await this.connector;
    return await this.licenseConnection.invoke('CloseSession', path, videoScope);
  }

  onreconnected(func) {
    this.licenseConnection.onreconnected(func);
  }

  onActiveSessionStatsChanged(func) {
    this.licenseConnection.on('ActiveSessionStatsChanged', func);
  }

  onLicenseUpdated(func) {
    this.licenseConnection.on('LicenseUpdated', func);
  }

  onNotifyLicenseExpiration(func) {
    this.licenseConnection.on('NotifyLicenseExpiration', func);
  }

  onNotifyCloseRemoteSessionFailed(func) {
    this.licenseConnection.on('NotifyCloseRemoteSessionFailed', func);
  }
}

export { LicenseService };
